import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { SaharaRules } from './SaharaRules';
export class SaharaFreedomHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const zeroFreedoms = SaharaRules.get().getBoardValuesFor(node.gameState, Player.ZERO);
        const oneFreedoms = SaharaRules.get().getBoardValuesFor(node.gameState, Player.ONE);
        return PlayerNumberTable.of(zeroFreedoms, oneFreedoms);
    }
}
